import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/** Access the SWA auth state (profile, token, login/logout). */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}
